import { render, staticRenderFns } from "./V2CourseCard.vue?vue&type=template&id=22e5f4c2&scoped=true&"
import script from "./V2CourseCard.vue?vue&type=script&lang=js&"
export * from "./V2CourseCard.vue?vue&type=script&lang=js&"
import style0 from "./V2CourseCard.vue?vue&type=style&index=0&id=22e5f4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e5f4c2",
  null
  
)

export default component.exports